import {lazy, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {usePermissions} from './usePermissions'

// Creates a lazy loader with a minimum load time of 300 seconds to allow the suspense fallback to show long enough to make sense
export const minimumDelayLazyLoader = (filename) =>
  lazy(() =>
    Promise.all([
      import(`../components/SettingsTabs/${filename}/index.jsx`),
      new Promise((resolve) => {
        setTimeout(resolve, 300)
      }),
    ]).then(([moduleExports]) => moduleExports),
  )

const PaymentMethodsTab = minimumDelayLazyLoader('PaymentMethodsTab')

export const useSettingsTabs = () => {
  const {t} = useTranslation('pointsOnPayments')
  const {data, isLoading} = usePermissions()

  const {screenAccess: {settingsScreen: settingsUnlocked} = {}} = data || {}

  // If settings are not unlocked yet then the product will not contribute any tabs to the settings page
  const settingsTabs = useMemo(
    () =>
      settingsUnlocked
        ? [
            {
              tabName: 'paymentMethods',
              label: t('pointsOnPayments:settingsTabs.paymentMethods.label'),
              component: <PaymentMethodsTab />,
            },
          ]
        : [],
    [settingsUnlocked, t],
  )

  return {
    isLoading,
    settingsTabs,
  }
}
